// hooks/useTinyUrl.ts
import { useState } from 'react';

export const useTinyUrl = () => {
  const [shortUrl, setShortUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createShortUrl = async (longUrl: string) => {
    setLoading(true);
    setError(null);

    try {
      const res = await fetch('/api/shorten', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url: longUrl }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data?.error || 'Failed to shorten URL');

      setShortUrl(data.shortUrl);
      return data.shortUrl as string;
    } catch (err: unknown) {
      const message =
        err instanceof Error ? err.message : 'Something went wrong';
      setError(message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { shortUrl, createShortUrl, loading, error };
};
